// NOVOLD PDP Sticky CTA — Phase 1.5
// - CTAクリック → main BUY area scrollIntoView
// - 購入モード（onetime/subscription）を
//   blocks/purchase-options.liquid のラジオから購読してバッジに反映（定期は1か月ごと固定）

(function () {
  "use strict";

  function findMainBuyTarget(anchor) {
    if (anchor) {
      try {
        const el = document.querySelector(anchor);
        if (el) return el;
      } catch (_) { /* invalid selector */ }
    }
    return (
      document.querySelector('purchase-options-component') ||
      document.querySelector('product-form-component') ||
      document.querySelector('[data-purchase-options]') ||
      document.querySelector('main form[action*="/cart/add"]') ||
      null
    );
  }

  function scrollTo(target) {
    if (!target) {
      console.warn('[pdp-sticky-cta] main BUY target not found');
      return;
    }
    target.scrollIntoView({ behavior: 'smooth', block: 'center' });
    const focusable = target.querySelector('input:not([type="hidden"]):not([disabled]), button:not([disabled])');
    if (focusable) {
      setTimeout(() => focusable.focus({ preventScroll: true }), 400);
    }
  }

  // 現在の購入モードを取得（お届けペースUIは廃止済み・定期=1か月ごと固定のため freq は扱わない）
  // NOVOLD 2026-09-06: purchase-options（単発/定期ラジオ）が描画される商品は今は無い
  // （通常商品はselling planを外し、定期専用(-sub)商品は月ごとプラン名の不一致でウィジェットが
  // 出ない）。ラジオが見つからない場合は「判定不能(null)」を返し、Liquidが決めた初期表示
  // （data-stcta-mode-badge の data-mode）を上書きしない。旧実装は無条件で'onetime'扱いにしており、
  // 定期専用商品でも常に「単発購入」に上書きされてしまっていた。
  function readPurchaseState() {
    const purchaseRadio = document.querySelector('[data-purchase-radio]:checked');
    return { mode: purchaseRadio ? purchaseRadio.value : null };
  }

  function applyState(root, state) {
    // data-stcta-save-badge は実額と乖離する「-10%」固定表示だったため撤去済み（no-op化）。
    // variant切替時にsticky barがmorphされてもこのスクリプトは再計算のフックを持たず、
    // 実額表示に切り替えても古い金額が残留する恐れがあり確実性に欠けるため表示自体をやめた。
    const modeBadges = root.querySelectorAll('[data-stcta-mode-badge]');

    modeBadges.forEach(b => {
      // ラジオが無い（state.mode === null）場合は、バッジ自身が既に持っている data-mode
      // （Liquidの初期表示。通常商品=onetime / 定期専用商品=subscription）を維持する。
      const mode = state.mode || b.getAttribute('data-mode') || 'onetime';
      if (mode === 'onetime') {
        b.textContent = b.dataset.modeLabelOnetime || '単発購入';
        b.setAttribute('data-mode', 'onetime');
      } else {
        b.textContent = b.dataset.modeLabelSub || '定期 1か月ごと';
        b.setAttribute('data-mode', 'subscription');
      }
    });
  }

  function bindPurchaseObserver(root) {
    const update = () => applyState(root, readPurchaseState());

    // 初回反映（DOM が後から組まれる可能性も考慮）
    update();

    // ラジオの change を監視
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !t.matches) return;
      if (t.matches('[data-purchase-radio]')) {
        update();
      }
    });

    // purchase-options-component が遅延描画される場合の遅延再判定
    setTimeout(update, 250);
    setTimeout(update, 1000);
  }

  function init(root) {
    const anchor = root.dataset.mainBuyAnchor || '';

    root.querySelectorAll('[data-stcta-cart], [data-stcta-buy]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        const target = findMainBuyTarget(anchor);
        scrollTo(target);
      });
    });

    root.querySelectorAll('[data-stcta-fav]').forEach(btn => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        // TODO: wishlist app 導入時に実装
      });
    });

    bindPurchaseObserver(root);
  }

  // NOVOLD 定期専用商品(-sub) selling_plan hidden input 追従 — NC-2026-125
  // blocks/buy-buttons.liquid の <product-form-component> はサイズ・挽き方を切り替えると
  // variant-picker.js が Section Rendering（fetch）で新バリアントのHTMLを取得し、
  // product-form.js の 'variant:update' ハンドラが input[name="id"] の値を直接
  // 書き換える（`.product-form-buttons` のmorph対象に selling_plan hidden input が
  // 含まれないケースがあり、morph任せだと古いプランIDのまま取り残される）。
  // snippets/quantity-selector.liquid が埋め込む
  // input[name="selling_plan"][data-selling-plan-map] を、バリアント切替のたびに
  // マップから引いた値へ更新する。
  function bindSellingPlanFollow() {
    function getSellingPlanInputs() {
      return Array.prototype.slice.call(
        document.querySelectorAll('input[name="selling_plan"][data-selling-plan-map]')
      );
    }

    function parseMap(input) {
      try {
        return JSON.parse(input.dataset.sellingPlanMap || '{}');
      } catch (e) {
        console.warn('[pdp-sticky-cta] invalid data-selling-plan-map', e);
        return {};
      }
    }

    function valueFromMap(map, variantId) {
      if (!variantId) return '';
      const value = map[String(variantId)];
      return value != null ? value : '';
    }

    function updateSellingPlanInput(input) {
      const form = input.closest('form');
      const idInput = form && form.querySelector('input[name="id"]');
      const variantId = idInput ? idInput.value : '';
      const nextValue = valueFromMap(parseMap(input), variantId);
      if (input.value !== nextValue) {
        input.value = nextValue;
      }
    }

    function updateAll() {
      getSellingPlanInputs().forEach(updateSellingPlanInput);
    }

    // (a) input[name="id"] の value 属性変化をフォールバックとして監視する。
    // このテーマの product-form.js は `variantId.value = ...` とIDLプロパティで
    // 直接書き換えるため value 属性自体は変化せず、この経路では基本発火しない想定だが、
    // 将来の実装変化に備えたセーフティネットとして残す。
    const observedIdInputs = new WeakSet();
    function observeIdInputs() {
      getSellingPlanInputs().forEach((input) => {
        const form = input.closest('form');
        const idInput = form && form.querySelector('input[name="id"]');
        if (!idInput || observedIdInputs.has(idInput)) return;
        observedIdInputs.add(idInput);
        new MutationObserver(() => updateSellingPlanInput(input)).observe(idInput, {
          attributes: true,
          attributeFilter: ['value'],
        });
      });
    }

    // (c) Section Rendering でフォーム自体（複合リスティング等でmainごと差し替わる場合）が
    // 丸ごとmorphされるケースに備え、フォームの子孫変化も監視して再取得・再監視する。
    const observedForms = new WeakSet();
    function observeForms() {
      document.querySelectorAll('form[action*="/cart/add"]').forEach((form) => {
        if (observedForms.has(form)) return;
        observedForms.add(form);
        new MutationObserver(() => {
          updateAll();
          observeIdInputs();
        }).observe(form, { childList: true, subtree: true });
      });
    }

    // 初期化時にも一度実行（初期表示はLiquidが正しい値を出しているはずだが念のため揃える）
    updateAll();
    observeIdInputs();
    observeForms();

    // 最も確実な経路: バリアント確定後に product-form.js 自身が input[name="id"] を
    // 更新するのと同じ 'variant:update' イベント（assets/events.js・bubbles:true）で追従する。
    // event.detail.resource.id に新バリアントIDが載っているため、
    // input[name="id"] の書き換えタイミング待ちをせず直接引ける。
    document.addEventListener('variant:update', (e) => {
      const variantId = e && e.detail && e.detail.resource && e.detail.resource.id;
      getSellingPlanInputs().forEach((input) => {
        const nextValue = valueFromMap(parseMap(input), variantId);
        if (input.value !== nextValue) {
          input.value = nextValue;
        }
      });
      // フォームが差し替わっている可能性があるため観測対象も更新する
      observeIdInputs();
      observeForms();
    });

    // (b) document の 'change' イベント（バリアント選択のラジオ/セレクト）でも再評価する。
    // Section Rendering の fetch は非同期のため change 発火時点では
    // input[name="id"] の値がまだ更新されていないことがあり、
    // bindPurchaseObserver と同じ遅延パターン（250ms/1000ms）で再評価する。
    document.addEventListener('change', (e) => {
      const t = e.target;
      if (!t || !t.closest || !t.closest('variant-picker')) return;
      updateAll();
      setTimeout(updateAll, 250);
      setTimeout(updateAll, 1000);
    });
  }

  function boot() {
    document.querySelectorAll('[data-pdp-sticky-cta]').forEach(init);
    bindSellingPlanFollow();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
